var _excluded = ["label", "helperText", "info", "fullWidth", "error", "disabled"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { Box } from "../..";
import TextField from '@material-ui/core/TextField';
import InputComponent from "./InputComponent";
import StandardLabel from "./StandardLabel";
import { useStyles } from "./Control.styles";
import { isEmpty } from "../../../helpers/data";
export var Control = function Control(_ref) {
  var innerProps = _ref.innerProps,
      innerRef = _ref.innerRef,
      selectProps = _ref.selectProps,
      isFocused = _ref.isFocused,
      children = _ref.children;
  var classes = selectProps.classes,
      variant = selectProps.variant,
      size = selectProps.size,
      value = selectProps.value,
      isMulti = selectProps.isMulti,
      menuIsOpen = selectProps.menuIsOpen,
      TextFieldProps = selectProps.TextFieldProps;

  var label = TextFieldProps.label,
      helperText = TextFieldProps.helperText,
      info = TextFieldProps.info,
      fullWidth = TextFieldProps.fullWidth,
      error = TextFieldProps.error,
      disabled = TextFieldProps.disabled,
      restProps = _objectWithoutProperties(TextFieldProps, _excluded);

  var styles = useStyles({
    isFocused: isFocused,
    isMulti: isMulti,
    menuIsOpen: menuIsOpen,
    fullWidth: fullWidth,
    disabled: disabled,
    error: error,
    size: size,
    variant: variant
  });
  var inputProps = {
    inputComponent: InputComponent,
    classes: {
      root: variant === 'inline' ? styles.inlineFieldRoot : styles.textFieldRoot,
      focused: styles.textFieldFocused,
      notchedOutline: styles.textFieldNotchedOutline,
      underline: styles.underline
    },
    inputProps: _objectSpread({
      className: classes.input,
      ref: innerRef,
      children: children
    }, innerProps)
  };

  var commonProps = _objectSpread({
    InputProps: inputProps,
    inputProps: _objectSpread({
      ref: innerRef,
      children: children
    }, innerProps),
    className: styles.root
  }, restProps);

  if (variant === 'standard') {
    return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(StandardLabel, {
      info: info,
      label: label,
      size: size
    }), /*#__PURE__*/React.createElement(TextField, _extends({
      helperText: error ? helperText : null,
      variant: "outlined"
    }, commonProps), children));
  }

  var updatedLabel = isFocused || !isEmpty(value) ? label : '';
  return /*#__PURE__*/React.createElement(TextField, _extends({
    helperText: helperText,
    label: updatedLabel
  }, commonProps));
};